/**
 * Render a timestamp as both relative ("vor 3 Min.") and absolute
 * (tooltip via `title`). Lightweight, no date-fns import — we already
 * have it but want zero runtime cost for an inline chip.
 */
const fmtAbs = new Intl.DateTimeFormat('de-DE', {
  dateStyle: 'medium',
  timeStyle: 'short',
});

const UNITS = [
  { limit: 60, divisor: 1, suffix: 'Sek.' },
  { limit: 3600, divisor: 60, suffix: 'Min.' },
  { limit: 86_400, divisor: 3600, suffix: 'Std.' },
  { limit: 604_800, divisor: 86_400, suffix: 'Tg.' },
  { limit: 2_629_800, divisor: 604_800, suffix: 'Wo.' },
  { limit: 31_557_600, divisor: 2_629_800, suffix: 'Mon.' },
  { limit: Infinity, divisor: 31_557_600, suffix: 'J.' },
];

function relative(iso) {
  if (!iso) return '—';
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return iso;
  const deltaSec = Math.round((Date.now() - then) / 1000);
  const absDelta = Math.abs(deltaSec);
  if (absDelta < 5) return 'gerade eben';
  const unit = UNITS.find((u) => absDelta < u.limit) ?? UNITS[UNITS.length - 1];
  const n = Math.round(absDelta / unit.divisor);
  return deltaSec >= 0 ? `vor ${n} ${unit.suffix}` : `in ${n} ${unit.suffix}`;
}

export function RelativeTime({ iso }) {
  if (!iso) return <span className="text-muted">—</span>;
  return (
    <time dateTime={iso} title={fmtAbs.format(new Date(iso))}>
      {relative(iso)}
    </time>
  );
}
